"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const auth_1 = require("../../auth");
const exceptions_1 = require("../exceptions");
/**
 * Esegue la richiesta se il token esiste e non è scaduto,
 * in caso contrario, viene richiesto un nuovo token e poi continua con la richiesta.
 *
 * @export
 * @class RefreshExpiredToken
 * @implements {ApiMiddleware}
 * @throws Unauthorized
 */
class RefreshExpiredToken {
    constructor(data) {
        if (auth_1.Auth.check()) {
            return auth_1.Auth.getAuthenticationAccessToken().isExpired()
                ? new Promise((resolve, reject) => {
                    auth_1.Auth.refresh()
                        .then(() => {
                        resolve(data);
                    })
                        .catch(reject);
                })
                : Promise.resolve(data);
        }
        throw new exceptions_1.Unauthorized();
    }
}
exports.default = RefreshExpiredToken;
